import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GridModule } from '@progress/kendo-angular-grid';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule, ROUTE_STRATEGY } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthcallbackComponent } from './authcallback/authcallback/authcallback.component';
import { CoreModule } from './core/core.module';
import { FullLayoutComponent } from './Layouts/full-layout/full-layout.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { AddressService } from './shared/services/address/address.service';
import { OnDemandPreloadService } from './shared/services/preloadOnDemandService';
import { SharedModule } from './shared/shared.module';
import { SubNavFullWidthComponent } from './layouts/sub-nav-full-width.component';
import { PrintLayoutComponent } from './print-to-pdf/print-layout/print-layout.component';
import { ApartmentInfoTemplateComponent } from './print-to-pdf/templates/apartment-info-template/apartment-info-template.component';

@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    AuthcallbackComponent,
    LoaderComponent,
    SubNavFullWidthComponent,
    PrintLayoutComponent,
    ApartmentInfoTemplateComponent
  ],
  imports: [
    // Root Routing Module
    AppRoutingModule,

    // Angular Functionality Imports
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,

    // NG Imports
    NgbModule,
    ToastrModule.forRoot(),

    // Kendo Imports
    // GridModule,
    UploadModule,


    // RRSM Module Imports
    CoreModule,
    SharedModule
  ],
  providers: [
    ROUTE_STRATEGY,
    AddressService,
    OnDemandPreloadService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
